import React from 'react';

const IconRenderer = (Comp, className?: string) => {
  return <Comp className={className ? className : ''} />;
};

export default IconRenderer;
